import React from 'react';
import SEO from '../../components/ui/SEO';
import ServicePageTemplate from '../../components/ui/ServicePageTemplate';
import { servicePages } from '../../data/services';
export default function ForensicRisk() {
  return <main className="min-h-screen bg-white" data-id="element-1082" data-mp="20te3h04higrn">
      <SEO title="Fitness to Plead and Criminal Psychiatric Reports" description="Independent criminal psychiatric reports: fitness to plead, mental state, Parole Board, extradition and prison assessments. Request a fee quote." path="/services/forensic-risk" keywords={['fitness to plead psychiatrist', 'criminal psychiatric report', 'Parole Board psychiatric report', 'extradition psychiatric report']} imageAlt="Criminal psychiatric reports and fitness to plead assessments" schema={{
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Criminal Psychiatric Reports and Fitness to Plead',
      serviceType: 'Forensic psychiatric assessment',
      url: 'https://medicolegal-psychiatry.co.uk/services/forensic-risk',
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'England and Wales'
      },
      provider: {
        '@type': 'Organization',
        name: 'Medicolegal Psychiatry',
        url: 'https://medicolegal-psychiatry.co.uk'
      },
      audience: {
        '@type': 'Audience',
        name: 'Legal professionals'
      },
      description: 'Psychiatric reports on fitness to plead, mental state at the time of an offence, sentencing, Parole Board reviews, licence conditions and extradition.'
    }} data-id="element-1083" data-mp="20scqgq3wrk7a" />
      <ServicePageTemplate content={servicePages.forensic} data-id="element-1084" data-mp="3jaurx505xvwq" />
    </main>;
}